import { responsiveFontSizes, createTheme } from '@mui/material/styles';
import { AapColors } from './AapColors';

// A custom theme for this app
let featuresTheme = createTheme({
    typography: {
        allVariants: {
            fontFamily: "Alegreya Sans",
            textTransform: "none",
        },
        h1: {
            fontWeight:"bold",
            fontSize:"48px",
        },
        h2: {
            fontWeight:"bold",
            fontSize:"2.75rem",
        },
        h3: {
            fontWeight:"bold",
            fontSize:"32px",
        },
        h4: {
            fontWeight:"bold",
            color:AapColors.AapIndigo,
            fontSize:"28px",
        },
        h5: {
            fontWeight:"bold",
            color:AapColors.AapIndigo,
            fontSize:"24px",
        },
        h6: {
            fontWeight:"bold",
            color:AapColors.AapIndigo,
            fontSize:"20px",
        },
        button: {
            fontWeight: "bold",
            color: AapColors.Blue,
        },
        body1: {
            color: AapColors.AapBlack,
            fontSize: "16px"
        },
        body2: {
            color: AapColors.AapBlack,
            fontSize: "1.25rem"
        },
        subtitle1: {
            color: AapColors.AapBlack,
            fontSize: "20px"
        },
        subtitle2: {
            color: AapColors.AapBlack,
            fontWeight:"bold",
            fontSize:"2.25rem",
        }
    },

    palette: {
        primary: {
            main: AapColors.AapIndigo,
            dark: AapColors.AapBrightIndigo,
            light: AapColors.AapSaturatedIndigo,
            contrastText: AapColors.White,
        },
        secondary: {
            main: AapColors.AapIndigo,
            dark: AapColors.AapBlack,
            light: AapColors.Blue,
            contrastText: AapColors.White,
        },

    },
    shape: {
        borderRadius: 0,
    }, 
    components: {
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    color: AapColors.AapBlack, 
                    fontSize: "24px",
                }
            },
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    whiteSpace: "unset",
                    wordBreak: "break-all",
                }
            }
        },
        MuiPaginationItem: {
            styleOverrides: {
                root: ({ ownerState }) => (ownerState.selected==true ? {
                        ...(
                        {
                            backgroundColor: AapColors.AapBackground,
                            color: AapColors.AapBrightIndigo,
                            fontSize: "18px",
                            fontWeight: "bold",
                        }),
                    } : {
                        ...(
                        {
                            color: AapColors.AapIndigo,
                            fontSize: "18px",
                            fontWeight: "bold",
                            ":hover": {
                                backgroundColor: AapColors.AapBackground,
                                color: AapColors.AapBrightIndigo,
                            },
                        }),
                    }),
                firstLast: {
                    border: 0,
                },
                previousNext: {
                    border: 0,
                },
            }
        },
    },
});
featuresTheme = responsiveFontSizes(featuresTheme);

export  {featuresTheme as FeaturesTheme};